<template>
  <div class="login" :class="{ 'login--highlighted': shouldShowPasswordField, 'login--failed': hasFailureMsg }">
    <email-input
        v-model="value.email"
        :disabled="value.loggedIn"
        v-on:input="emailInput"
        :loading="loading">
    </email-input>
  
    <div v-if="value.loggedIn" class="logout-btn">
        Not you? <span v-on:click="logOut">Log Out</span>
    </div>

    <fieldset v-if="shouldShowPasswordField">
        <input-with-validation
            type="password"
            label="Password"
            v-model="password"
            login-on-enter="true">
        </input-with-validation>

        <div v-show="hasFailureMsg" class="login__failure-msg" v-html="failureMsg"></div>

        <div class="login__buttons flex gutter">
            <button class="button button--primary" :class="{'btn--disabled': loginBtnDisabled}" type="button" v-on:click="attemptLogin">Log In</button>
            <button class="button button--primary-alternate" type="button" v-on:click.prevent="continueAsGuest">Continue as Guest</button>
        </div>
    </fieldset>

  </div>
</template>

<script>
  import emailInput from './emailInput'
  import inputWithValidation from './inputWithValidation'
  import UserProvider from '../services/UserProvider'
  import { User } from '../models/Booking'

  export default {
    name: 'userLogin',
    props: [
      'value'
    ],
    components: {
      emailInput,
      inputWithValidation
    },
    data () {
      return {
        failureMsg: null,
        loginBtnDisabled: false,
        shouldShowPasswordField: false,
        password: null,
        loading: false
      }
    },
    mounted () {
      this.userProvider = new UserProvider()
    },
    methods: {
      continueAsGuest () {
        this.hidePasswordField()
      },
      attemptLogin () {
        const email = this.value.email
        const password = this.password

        this.loginBtnDisabled = true

        this.userProvider.attemptLogin(email, password)
          .then((user) => {
            this.$emit('input', user)
            this.hidePasswordField()
          })
          .catch((error) => {
            if (error) {
              this.failureMsg = 'Incorrect username or password'
            }
          })
          .then(() => {
            this.loginBtnDisabled = false
          })
      },
      logOut () {
        const noUser = new User()

        this.$emit('input', noUser)
      },
      showPasswordField () {
        this.shouldShowPasswordField = true
        this.password = null
        this.failureMsg = null
      },
      hidePasswordField () {
        this.shouldShowPasswordField = false
      },
      emailInput (email) {
        this.loading = true
        this.hidePasswordField()
        this.userProvider.checkEmailExists(email)
          .then((exists) => {
            this.shouldShowPasswordField = exists
            this.loading = false
          })
      },
      highlightError () {
      },
      isValid () {
        return true
      }
    },
    computed: {
      hasFailureMsg: function () {
        return this.failureMsg !== null
      }
    }
  }
</script>



// WEBPACK FOOTER //
// userLogin.vue?0b9d25aa